import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { HueLogoWhiteIcon } from 'assets/icons'
import Support from 'components/Support'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    height: theme.custom.mobileAuthNavbarHeight,
    position: 'sticky',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 2,
    paddingInline: '16px',
  },
}))

const AuthNavbar = () => {
  const classes = useStyles()
  return (
    <Grid className={classes.root}>
      <span />
      <HueLogoWhiteIcon
        sx={{
          '& rect': { fill: '#E4CAFB' },
          '& #Vector': { fill: 'black' },
          width: '106px',
          height: '32px',
        }}
      />
      <Support title="" iconProps={{ fill: 'black' }} />
    </Grid>
  )
}

export default AuthNavbar
